// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/circuit-joining-uncontrolled.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/circuit-joining-uncontrolled/circuit-joining-uncontrolled.js';

mount([g0]);
